 export const muiLink = {
    styleOverrides: {
        root: {
            cursor: 'pointer',
            lineHeight: '2.5'
        }
    }
}